import { defineStore } from 'pinia';

import { IProduct } from '@/types/product';
import { LOCAL_STORAGE_CART_ID } from '@/constants';

interface CartState {
	products: IProduct[];
	subTotal?: number;
	currency?: string;
}

const defaultCartState: CartState = {
	products: [],
};

export const useCartStore = defineStore({
	id: 'cartStore',
	state: (): CartState => {
		try {
			const ls = localStorage.getItem(LOCAL_STORAGE_CART_ID) || '{}';
			const storageAppData = JSON.parse(ls);
			const _state = useMergeWith(defaultCartState, storageAppData, (objValue, srcValue) => {
				if (!srcValue) return objValue;
				return srcValue;
			});
			return _state;
		} catch (_) {
			return defaultCartState;
		}
	},
	actions: {
		editCart(cartItem: IProduct) {
			const _products = [...this.products];
			const index = _products.findIndex((prod: IProduct) => {
				return cartItem.productId === prod.productId;
			});
			if (index === -1) {
				_products.push(cartItem);
			} else {
				if (cartItem.quantity === 0) {
					_products.splice(index, 1);
				} else {
					_products[index] = cartItem;
				}
			}
			this.products = [..._products];
			this.persistenceState();
		},
		resetCart() {
			this.products = [];
			this.persistenceState();
		},
		persistenceState() {
			localStorage.setItem(LOCAL_STORAGE_CART_ID, JSON.stringify(this.$state));
		},
	},
	getters: {
		getProducts: (state) => {
			return (): IProduct[] => {
				return state.products;
			};
		},
		getSubtotal: (state) => {
			return () => {
				const subtotal = state.products.reduce(
					(partialSum, product: IProduct) => partialSum + product.productSellingPrice * product.quantity,
					0,
				);
				//subtotal = subtotal - (subtotal * DISCOUNT) / 100;
				return subtotal;
			};
		},
	},
});
